const clean = (value) => String(value ?? "").trim();
const key = (value) => clean(value).toLowerCase();

export const linkQuilterSourcesToAdviser = ({
  adviserLinks = [],
  sourceNames = [],
  adviser = {},
}) => {
  const email = clean(adviser.email || adviser.targetId).toLowerCase();
  const adviserName = clean(adviser.name) || email;
  const sources = [...new Map(
    sourceNames
      .map(clean)
      .filter(Boolean)
      .map((sourceName) => [key(sourceName), sourceName]),
  ).values()];
  const sourceKeys = new Set(sources.map(key));

  if (!email || !sources.length) return adviserLinks;

  return [
    ...adviserLinks.filter(
      (link) => !sourceKeys.has(key(link.sourceAdviserName)),
    ),
    ...sources.map((sourceAdviserName) => ({
      sourceAdviserName,
      adviserName,
      email,
    })),
  ];
};
